import { Box } from "@mui/material"

const validateDataTable = (data) => {

    const response = []

    if (!data?.nomeTabela > 0)
        response.push(<Box>Digite um nome para a tabela.</Box>)

    if (data?.grupo_filial.length === 0)
            response.push(<Box>Selecione um grupo filial.</Box>)
    
    if (response.length === 0)
        return ''

    return (response)
}

export default validateDataTable